import { useCallback, useEffect, useState } from "react"
import api from "../../../../../services/api";
import { useAuth } from "../../../../../hooks/auth";
import { useMemo } from "react";
import { toastError } from "../../../../../toasts";

export const useFlavors = ({ groupId }) => {
    const [group, setGroup] = useState(null);
    const [flavors, setFlavors] = useState([]);
    const [selectedFlavors, setSelectedFlavors] = useState([]);
    const [modalSelectFlavor, setModalSelectFlavor] = useState(false);
    const { id_empresa } = useAuth();

    const handleModalSelectFlavor = useCallback(() => {
        setModalSelectFlavor(prev => !prev)
    }, [setModalSelectFlavor])

    const getFlavors = useCallback(async () => {
        try {
            const { data } = await api.get(`produto/listarPizzas/${id_empresa}`);

            setFlavors(data);
        } catch (error) {
            console.error(error)
        }
    }, [])

    const getGroup = useCallback(async () => {
        try {
            const { data } = await api.get(`grupo-produto/encontrar/${groupId}`);
            if (!data?.Id) {
                throw new Error('grupo não encontrado');
            }
            setGroup(data)
        } catch (error) {
            console.log(error);
        }
    }, [groupId, id_empresa])

    const getSelectedFlavors = useCallback(async () => {
        try {
            const { data } = await api.get(`grupo-pizzas/listar/${groupId}`);

            setSelectedFlavors(data);
        } catch (error) {
            console.error(error)
        }
    }, [])

    const handleDeleteSelection = useCallback(async (flavorId) => {
        try {
            const selected = selectedFlavors.find(selectd => selectd.IdProduto === flavorId);

            await api.delete(`grupo-pizzas/${selected.Id}`);

            getSelectedFlavors();
        } catch (error) {
            console.error(error);
            toastError("Não foi possivel apagar seleção");
        }
    }, [getSelectedFlavors, selectedFlavors])

    const handleUseSelected = useCallback(async () => {
        try {

            const { data } = await api.patch(`grupo-produto/alterar/${group.Id}`, {
                UsaSaboresSelecionados: !group?.UsaSaboresSelecionados
            });

            setGroup(prev => ({ ...prev, UsaSaboresSelecionados: data?.UsaSaboresSelecionados }));
        } catch (error) {
            console.error(error);
            toastError("Não foi possivel apagar seleção");
        }
    }, [group])

    const groupSelectedFlavors = useMemo(() => {
        const selectedFlavorsIds = selectedFlavors.map(curr_selected => curr_selected.IdProduto);
        return flavors.filter(curr_flavor => selectedFlavorsIds.includes(curr_flavor.Id))
    }, [selectedFlavors, flavors])

    useEffect(() => {
        getFlavors();
        getSelectedFlavors();
    }, [getFlavors, getSelectedFlavors])

    useEffect(() => {
        getGroup();
    }, [groupId])

    return {
        group,
        flavors,
        groupSelectedFlavors,
        modalSelectFlavor,
        selectedFlavors,
        handleModalSelectFlavor,
        getSelectedFlavors,
        handleDeleteSelection,
        handleUseSelected,
    }
}
